/*
 * @Author: 小周
 * @Date: 2026-07-23
 * @Description: 阿里云埋点（aplus）SDK 初始化 + 埋点封装
 */

import { getArticle } from '@/api/cms'

// ---------- SDK 初始化 ----------

/**
 * 动态加载 aplus SDK 脚本并配置元信息（仅执行一次）
 */
function loadAplusScript() {
  return new Promise((resolve) => {
    if (window.aplus_queue) {
      configAplusMeta()
      resolve()
      return
    }
    // 创建 aplus_queue 并注入 SDK 脚本
    ;(function (w, d, s, q) {
      w[q] = w[q] || []
      // trackDomain 等 metaInfo 必须在 SDK 初始化前就写入队列，
      // 否则 SDK 读取时值为 undefined 会报错
      w[q].push({ action: 'aplus.setMetaInfo', arguments: ['appKey', 'qx0x2z5gbx0hadbmpk7gejcu'] })
      w[q].push({ action: 'aplus.setMetaInfo', arguments: ['DEBUG', true] })
      w[q].push({ action: 'aplus.setMetaInfo', arguments: ['trackDomain', 'https://mediadata.xuexi.cn:8443/'] })
      const f = d.getElementsByTagName(s)[0]
      const j = d.createElement(s)
      j.async = true
      j.id = 'beacon-aplus'
      j.src = 'https://o.alicdn.com/QTSDK/quicktracking-sdk/qt_web.cjs.js'
      if (f && f.parentNode) {
        f.parentNode.insertBefore(j, f)
      }
    })(window, document, 'script', 'aplus_queue')

    // 监听 SDK 初始化完成
    window.aplus_queue.push({
      action: 'aplus.aplus_pubsub.subscribe',
      arguments: [
        'aplusReady',
        function (status) {
          if (status === 'complete') {
            console.log('SDK初始化完成')
            resolve()
          }
        },
      ],
    })
  })
}

/**
 * 配置 aplus 元信息（SDK 已就绪后的补充配置）
 */
function configAplusMeta() {
  const queue = window.aplus_queue
  if (!queue) return
  // SDK 初始化后仍可在队列中追加配置
  queue.push({ action: 'aplus.setMetaInfo', arguments: ['appKey', 'qx0x2z5gbx0hadbmpk7gejcu'] })
  queue.push({ action: 'aplus.setMetaInfo', arguments: ['DEBUG', true] })
  queue.push({ action: 'aplus.setMetaInfo', arguments: ['trackDomain', 'https://mediadata.xuexi.cn:8443/'] })
}

let aplusInitPromise = null

/**
 * 初始化 aplus 埋点 SDK（幂等，多次调用只执行一次）
 * @returns Promise 在 SDK 初始化完成后 resolve
 */
export function initAplus() {
  if (aplusInitPromise) return aplusInitPromise
  aplusInitPromise = loadAplusScript().then(() => {
    configAplusMeta()
  })
  return aplusInitPromise
}

// ---------- 底层：发送 PV ----------

/**
 * 阿里云 aplus 页面浏览（PV）埋点
 * @param pageData 页面自定义参数
 */
export function aplusSendPV(pageData) {
  const aplusQueue = window.aplus_queue || (window.aplus_queue = [])
  console.log('aplusSendPV', pageData)
  aplusQueue.push({
    action: 'aplus.sendPV',
    arguments: [
      {
        is_auto: false
      },
      {
        event_type: 'pageview',
        ...pageData
      }
    ]
  })
}


/**
 * 文章详情页 PV 埋点
 * 内部先调用 getArticle 接口获取文章数据，再组装埋点参数发送
 * @param articleId 稿件 ID
 * @returns Promise<void>
 */
export async function trackArticleDetail(articleId) {
  // 确保 SDK 初始化完成后再发送埋点
  await initAplus()
  const res = await getArticle(articleId)
  if (res.code === 0 && res.result) {
    const article = res.result
    // aplusSendPV({
    //   event_code: 'article_details_pg',
    //   current_page_name: TRACK_H5_PROJECT_NAME,
    //   current_page_id: 'article_details_pg',
    //   current_create_date: article.publishTime,
    //   article_name: article.articleTitle,
    //   article_type: String(article.articleType),
    //   article_author: article.articleAuthor,
    //   article_id: article.articleId,
    //   originality: '否',
    //   special_topic_name: '',
    //   page_name: 'article_details_pg',
    // })
    aplusSendPV({
      event_code: 'home_pg',
      current_channel_name: article.channelName,
      current_page_id: article.channelCode,
      current_page_name: article.articleTitle,
      page_name: 'home_pg',
    })
  }
  console.log('文章详情23131', res)
}
